import React from 'react';
import { SeoTestDetails } from '../types';
import { Icon, Tooltip } from 'antd';

type Props = {
    seoTestDetails: SeoTestDetails;
};

export default function FailedCheckTitle({ seoTestDetails }: Props) {
    return (
        <div className="failed-check-title">
            <Icon
                type="close-circle"
                theme="filled"
                className="status-icon"
            />
            <div><strong>{seoTestDetails.title}</strong></div>

            <Tooltip
                placement="right"
                title={<span dangerouslySetInnerHTML={{ __html: seoTestDetails.description }} />}
            >
                <Icon
                    type="info-circle"
                    theme="filled"
                    className="info-icon"
                />
            </Tooltip>

        </div>
    );
}
